import React, { useState } from 'react';
import './UserOrders.css';

function UserOrders({ filledOrders, pendingOrders, socket, positions, averageCosts, products, activeProduct, visibleProducts }) {
  const [activeTab, setActiveTab] = useState('filled');
  const [showAllOrders, setShowAllOrders] = useState(false);
  const POSITION_LIMIT = 1000; // Maximum position limit

  const handleCancelOrder = (order) => {
    if (socket) {
      const cancelMessage = {
        type: 'cancelOrder',
        orderId: order.id
      };
      socket.send(JSON.stringify(cancelMessage));
    }
  };

  // Filter pending orders based on active product if showAllOrders is false
  const filteredPendingOrders = showAllOrders 
    ? pendingOrders 
    : pendingOrders.filter(order => order.product === activeProduct);

  const renderOrders = (orders, showCancelButton = false) => {
    if (orders.length === 0) {
      return (
        <div className="no-orders-message">
          No pending orders{!showAllOrders ? ` for ${activeProduct}` : ''}
        </div>
      );
    }

    return orders.map((order, index) => (
      <div key={index} className={`order-entry ${order.side === "BUY" ? 'bid' : 'ask'}`}>
        <span>{order.side === "BUY" ? 'Buy' : 'Sell'}</span>
        <span>{order.type === 0 ? 'Market' : 'Limit'}</span>
        <span>{order.price}</span>
        <span>{order.quantity}</span>
        <span>{order.product}</span>
        {showCancelButton && (
          <button 
            className="cancel-button"
            onClick={() => handleCancelOrder(order)}
          >
            Cancel
          </button>
        )}
      </div>
    ));
  };

  return (
    <div className="user-orders">
      <div className="order-tabs">
        <button 
          className={`tab ${activeTab === 'filled' ? 'active' : ''}`}
          onClick={() => setActiveTab('filled')}
        >
          Positions
        </button>
        <button 
          className={`tab ${activeTab === 'pending' ? 'active' : ''}`}
          onClick={() => setActiveTab('pending')}
        >
          Pending Orders
        </button>
      </div>
      <div className="orders-content">
        {activeTab === 'filled' ? (
          <div className="positions-table">
            <table>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Position</th>
                  <th>Limit</th>
                </tr>
              </thead>
              <tbody>
                {visibleProducts.map(product => {
                  const position = positions[product] || 0;
                  
                  return (
                    <tr key={product}>
                      <td>{product}</td>
                      <td className={position > 0 ? 'positive' : position < 0 ? 'negative' : ''}>
                        {position}
                      </td>
                      <td>±{POSITION_LIMIT}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="pending-orders">
            <div className="orders-filter">
              <label className="toggle-label">
                <input
                  type="checkbox"
                  checked={showAllOrders}
                  onChange={() => setShowAllOrders(!showAllOrders)}
                />
                Show all orders
              </label>
              {!showAllOrders && activeProduct && <span className="filter-info">Showing orders for {activeProduct}</span>}
            </div>
            <div className="order-headers">
              <span>Side</span>
              <span>Type</span>
              <span>Price</span>
              <span>Qty</span>
              <span>Product</span>
              <span>Action</span>
            </div>
            <div className="orders-list">
              {renderOrders(filteredPendingOrders, true)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserOrders;